import { Builder } from "@builder.io/react";

import { Accordion } from "../../../slate/Accordion";
import { BuilderConfig as AccordionConfig } from "../../../slate/Accordion/Accordion.builder";

import { withTransformations } from "./withTransformations";

const BuilderAccordion = withTransformations(
  Accordion,
  AccordionConfig.transformations ?? {}
);

export const registerBuilderAccordion = () => {
  Builder.registerComponent(BuilderAccordion, {
    name: "Accordion",
    hideFromInsertMenu: false,
    inputs: [
      {
        name: "title",
        type: "string",
        defaultValue: "You may be wondering",
        localized: true,
      },
      {
        name: "titleAlignment",
        type: "string",
        enum: ["center", "end", "justify", "left", "right", "start", "unset"],
      },
      {
        name: "contents",
        type: "list",
        subFields: [
          {
            name: "question",
            type: "string",
            localized: true,
          },
          {
            name: "answer",
            type: "richText",
            localized: true,
          },
        ],
      },
    ],
  });
};
